const COLLECTION_ROUTES = new Set(['/', '/projects', '/research']);
const INTERACTIVE_TARGETS = 'a, button, input, select, textarea, summary, audio, video, iframe, [role="button"], [role="link"], [contenteditable]:not([contenteditable="false"]), [data-full-src], .scroll-container';

export function collectionDetailRoute(entry) {
  const route = entry && entry.route;
  if (typeof route !== 'string' || !route.startsWith('/') || route.startsWith('//')) return '';
  const path = route.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return COLLECTION_ROUTES.has(path) ? '' : route;
}

export function shouldNavigateCollectionDetail(event, selection) {
  if (!event || event.defaultPrevented || event.altKey) return false;
  if (event.type === 'keydown') {
    if (event.key !== 'Enter' || event.target !== event.currentTarget) return false;
  } else if (event.button != null && event.button !== 0) {
    return false;
  }
  if (selection && selection.isCollapsed === false) return false;

  const target = event.target && event.target.nodeType === 3
    ? event.target.parentElement
    : event.target;
  const interactive = target && target.closest ? target.closest(INTERACTIVE_TARGETS) : null;
  return !interactive || interactive === event.currentTarget;
}
